import React from 'react'
import propTypes from 'prop-types';
import './sidePanel.css'
import {
  navElements,
  CMSPath,
  compType
} from '../../config/constant'
import {
  HashRouter,
  Link,
  Redirect
} from 'react-router-dom'
import {
  roomAssistanceStatusChange,
  setNavItem,
  updateCurrentLayout,
  updateGuestLang,
  clickOnLogo,
  logoutFb,
  facebookProfile,
  setVideoPlayer,
  fbLogoutPopup,
  setAdminPage,
  popupOpenClose,
  firstOnHome,
  currentWidget,
  setRegPage
} from '../../action/action'
import { connect } from 'react-redux'
//import noImage from '../../images/Innspire_Logo_web.png'
import noImage from '../../images/mast-head.jpg'
import { logout } from '../shared/facebookOauth'
import { logoutM } from '../shared/facebookOauthMobile'
import { selectItemColor, setColor } from '../../JS/setColors'
import { playDoorCameraStream } from '../../JS/playDoorCameraStream'
import { forMobileMenu } from '../../JS/heightFix'

class sidePanel extends React.Component {
  constructor(props) {
    super(props);
    this.time = 0
    this.state = {
      currentActive: false,
      showMobileMenu: false,
      logoClick: false,
      logout: false,
      logoClickCount: 0,
      eventTouch: "click"
    }
  }

  componentDidMount() {
    selectItemColor(this.props.menuColor, "null");
  }
  //this function is to element in navigation with link to there components
  //fro demoit we have changes the code use nav prop to apply map
  navItems = () => {
    return (
      this.props.navList.map((iterator, index) => {
        if (iterator.compName !== "Butler Services") {
          return (
            <li
              id={`${iterator.id}`}
              className={
                this.state.currentActive === index ?
                  "link-item current"
                  : "link-item"}
              onClick={() => { this.onNavItemClick(index, iterator) }}>
              <Link
                style={{ color: "inherit" }}
                className={iterator.className}
                exact to={iterator.path}>
                {iterator.displayName}
                {
                  iterator.compImage ?
                    <img
                      style={{ width: "50px" }}
                      src={iterator.compImage} /> : iterator.compName
                }
              </Link>
            </li>
          )
        }
      })
    )
  }

  /*     
  style={{
background: `URL(${iterator.compImage})`,
 backgroundPosition: 'center center',
 backgroundRepeat: 'no-repeat'
   }} */
  onNavItemClick = (index, widget) => {
    let room = localStorage.getItem("room");
    if (this.props.GuestDevReg) {
      this.props.setRegPage(false);
    }
    //console.log("widget", widget);
    if (room && room !== "null") {
      selectItemColor(this.props.menuColor, widget.id);
    }
    this.props.currentWidget(widget);

    try {
      this.setState({ currentActive: index, logoClick: false });
      this.onClickHideMobileMenu();
      this.props.setVideoPlayer(false);
      if (widget.compName === "App Launcher") {
        //console.log("widget", widget);
        this.launcher(widget);
      }
      if (widget.compName === "Url Renderer") {
        console.log("url renderer", widget.targetUrl);
        window.open(widget.targetUrl);
      }
      if (widget.compName === "Hotel Guide") {
        console.log("Hotel Guide", `${CMSPath}${widget.targetUrl}`);
        if (widget.targetUrl) {
          if (window.cordova || window.device) {
            if (window.device.platform === "Android") {
              window.cordova.InAppBrowser.open(
                `${CMSPath}${widget.targetUrl}`,
                '_blank',
                'location=yes,hideurlbar=yes,closebuttoncaption=Back'
              );
            } else {
              window.cordova.InAppBrowser.open(
                `${CMSPath}${widget.targetUrl}`,
                '_blank',
                'location=no,closebuttoncaption=Back'
              );
            }
          } else {
            window.open(`${CMSPath}${widget.targetUrl}`);
          }
        }
      }
      if (widget.compName === "Door Camera") {
        console.log("called the door camera");
        if (this.props.streamingUrlFromConfig) {
          playDoorCameraStream(this.props.streamingUrlFromConfig, this.props);
        } else {
          console.log("URL is not there in client config.");
          this.props.popupOpenClose(true, "This functionality temporarily not available.");
        }
      }
    } catch (errorMsg) {
      console.log("error in on click", errorMsg);
    }
  }

  launcher = (widget) => {
    let launchInfo;
    this.props.appLauncherWidget.map(
      (iterator) => {
        if (widget.widgetTypeId === iterator.id) {
          launchInfo = iterator;
        }
      }
    )
    if (launchInfo.onClickTargetPackageId || launchInfo.onClickTargetIosUri) {
      if (window.device && window.device.platform === "Android") {
        window.plugins.launcher.launch(
          { packageName: launchInfo.onClickTargetPackageId, },
          //{ packageName: this.props.packageName, },
          () => { console.log("launched a link") },
          () => {
            console.log("error while launching link");
            this.props.popupOpenClose(true, "Unable to open this App.");
          }
        );
      } else if (window.device && window.device.platform === "iOS") {
        window.plugins.launcher.launch(
          { uri: launchInfo.onClickTargetIosUri, },
          // { uri: this.props.urlScheme, },
          () => { console.log("launched a link") },
          () => {
            console.log("error while launching link");
            this.props.popupOpenClose(true, "Unable to open this App.");
          }
        );
      } else {
        //console.log("it is not for desktop.");
        this.props.popupOpenClose(true, "Functionality of Lauching 3rd party app will not work from browser.");
      }
    } else {
      alert("both pakage name and URI scheme are not available.");
    }
  }
  onNavItemClick = (index) => {
    this.setState({ currentActive: index, logoClick: false });
    this.onClickHideMobileMenu();
    this.props.setVideoPlayer(false);
  }

  onRoomAssistanceClick = (index) => {
    this.setState({ currentActive: index });
    this.props.roomAssistanceStatusChange(true);
    this.onClickHideMobileMenu();
  }

  onLogoutClick = (index) => {
    this.props.fbLogoutPopup(true);
    selectItemColor(this.props.menuColor, "logout");
  }

  onClickShowMobileMenu = () => {
    this.setState({ showMobileMenu: true });
    forMobileMenu(true)
    console.log("onClickShowMobileMenu");
    selectItemColor(this.props.menuColor, "null");
  }
  onClickHideMobileMenu = () => {
    this.setState({ showMobileMenu: false });
    forMobileMenu(false)
  }

  goToHomePage = (event) => {
    if (this.state.eventTouch === event.type) {
      window.clearTimeout(this.time);
      //console.log("out in gohome method", event.type);
      this.setState({ logoClickCount: this.state.logoClickCount + 1 });
      //window.setTimeout(() => {
      if (this.state.logoClickCount <= 1) {
        //console.log("in gohome method", this.state.logoClickCount);
        this.props.clickOnLogo(true);
        this.props.setVideoPlayer(false);
        this.setState({
          logoClick: true,
          currentActive: 9999
        });
        this.props.setAdminPage(false);
      }
      // }, 500);
      this.time = window.setTimeout(() => {
        this.setState({ logoClickCount: 0 });
      }, 2000);
      if (this.state.logoClickCount >= 5) {
        //console.log("we are in admin access.");
        this.props.setAdminPage(true);
      }
    }
    if (event.type === "touchend") {
      this.setState({ eventTouch: "touchend" });
    }
  }
  goToHomePage = () => {
    this.props.clickOnLogo(true);
    this.props.setVideoPlayer(false);
    this.setState({ logoClick: true, currentActive: 9999 });
  }

  changeLayout = (event) => {
    if ("default" !== event.target.value && this.props.guestLanguages !== event.target.value) {
      //console.log("changeLayout");
      this.props.updateGuestLang(event.target.value, true);
    }
    /* 
    if (window.device) {
      window.cordova.plugins.Keyboard.hideKeyboardAccessoryBar(false);
    }
    */
    this.setState({ showMobileMenu: false });
  }

  getHotelLanguages = () => {
    return (
      this.props.hotelLanguage.languages ?
        this.props.hotelLanguage.languages.map((iterator) => {
          return <option value={`${iterator.languageCode}`}>{iterator.language}</option>
        }) : null
    )
  }

  onLogoClick = () => {
    if (this.props.GuestDevReg) {
      this.props.setRegPage(false);
    }
    this.props.currentWidget({});
    console.log("logo click.")
    if (this.props.menuColor && this.props.menuColor.assetBackgroundColor) {
      this.props.firstOnHome(true);
      selectItemColor(this.props.menuColor, "logo");
      setColor(this.props.menuColor);
    }
    this.props.clickOnLogo(false);
    return (
      <HashRouter>
        <Redirect exact to="/" />
      </HashRouter>
    )
  }
  testMethod = (props) => {
    // console.log("test method called.");
    //history.push(this.props.currentWidgetOb.path);
  }

  render() {
    return (

      <section id="app-nav" className="col">
        <button
          className="mobile-nav"
          onClick={this.onClickShowMobileMenu}>
          <span></span>
        </button>
        <div className="mast-head link-item" onClick={this.goToHomePage} onTouchEnd={this.goToHomePage}
          style={{ marginLeft: "-1px" }}
        >
          {
            this.props.logoClick ?
              this.onLogoClick()
              : null
          }
          <div className="home">
            {this.props.logo ?
              <img id="logoImage"
                src={this.props.logo ? `${CMSPath}${this.props.logo}` : null// require('../../images/link-icons/default_logo.svg')
                }
                alt="" />
              : null
            }
          </div>
        </div>
        {
          /*
        <button className="mobile-profile">
          profile 
        </button>*/
        }
        {
          // this.props.currentWidgetOb && this.props.currentWidgetOb.path ?
          //   <HashRouter>
          //     {this.testMethod(this.props)}
          //     {/* <Redirect exact to={`${this.props.currentWidgetOb.path}`} /> */}
          //   </HashRouter> : null
        }
        <HashRouter>
          <ul
            className={this.state.showMobileMenu ?
              "app-nav mobile-current"
              : "app-nav"
            }>
            <li className="nav-item">
              <a
                onClick={this.onClickHideMobileMenu}
                className="nav-btn-close">
              </a>
            </li>
            {
              /*
            <li className="nav-item">
              <select style={{ width: '100%' }} onChange={this.changeLayout}>
                <option value="default">Select your language</option>
                {this.getHotelLanguages()
                }
              </select>
            </li>
              */
              this.navItems()
            }
            {/*<li
              className={
                this.state.currentActive === 100 ?
                  "link-item current"
                  : "link-item"}
              onClick={() => { this.onRoomAssistanceClick(9999) }}>
              {navElements.length > 0 ?
                navElements.map((iterator, index) => {
                  if (iterator.text === "Butler Services") {
                    return (
                      <a href="#" className={iterator.className}>
                        Butler Services
                        <img src={require('../../images/link-icons/rs-icon.svg')} />
                      </a>
                    )
                  }
                }) : null
              }
            </li>*/}
            {/* <li
              className={
                this.state.currentActive === 200 ?
                  "link-item current"
                  : "link-item"}
              id="logout"
              onClick={() => { this.onLogoutClick(200) }}>
              <a href="#" className="logout">
                logout
                <img style={{ width: "50px" }} src={require('../../images/ico_logoff.png')} />
              </a>
            </li> */}
          </ul>
        </HashRouter>
      </section>

    )
  }
}

//export default sidePanel;
const mapStateToProps = state => {
  return {
    //
    roomAssistancePageStatus: state.store.roomAssistance.popupStatus,
    //
    navBarItem: state.store.home.currentDuration.scrollableWidgets ?
      state.store.home.currentDuration.scrollableWidgets.widgets : [],
    //
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    //
    navList: state.store.sideNavBar.navItems,
    //
    hotelLanguage: state.store.home.hotelLanguages.payload ?
      state.store.home.hotelLanguages.payload : {},
    //
    guestLanguages: state.store.home.guestLanguage ?
      state.store.home.guestLanguage.preferredLanguageCode : "",
    logoClick: state.store.sideNavBar.logoClick,
    currentWidgetOb: state.store.sideNavBar.currentWidget,
    fbStatus: state.store.fbStatus,
    packageName: state.store.appLauncher.packageApp,
    urlScheme: state.store.appLauncher.urlScheme,
    appLauncherWidget: state.store.appLauncher.widget,
    menuColor: state.store.home.MenuColor,
    streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
      state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
    streamingUrlFromVDA: state.store.roomControl.RoomControlStatus.zone.doorCameraFeed ?
      state.store.roomControl.RoomControlStatus.zone.doorCameraFeed.doorCameraFeedUrl : null,
    GuestDevReg: state.store.deviceReg.guestRegPag
  }
}

sidePanel.propTypes = {
  navList: propTypes.arrayOf(propTypes.object),
  guestLanguages: propTypes.string,
  hotelLanguage: propTypes.object,
  logo: propTypes.string,
  navBarItem: propTypes.arrayOf(propTypes.object),
  roomAssistancePageStatus: propTypes.bool,
  logoClick: propTypes.bool,
  fbStatus: propTypes.string
}

export default connect(
  mapStateToProps,
  {
    roomAssistanceStatusChange,
    setNavItem,
    updateCurrentLayout,
    updateGuestLang,
    clickOnLogo,
    logoutFb,
    facebookProfile,
    setVideoPlayer,
    fbLogoutPopup,
    setAdminPage,
    popupOpenClose,
    firstOnHome,
    currentWidget,
    setRegPage
  }
)(sidePanel);